import React, { FC } from 'react';
import classnames from 'classnames';
import { RecommendedUsersSortOptionEnum } from '@src/graphql/generated';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { QueryParams } from '../../interfaces/queryParams.interface';
import './styles.scss';

const SORT_OPTIONS = [
  {
    label: 'Joined recently',
    value: RecommendedUsersSortOptionEnum.JOINED_AT,
  },
  {
    label: 'Best matches',
    value: RecommendedUsersSortOptionEnum.RELEVANCE,
  },
  {
    label: 'Recently active',
    value: RecommendedUsersSortOptionEnum.LAST_SEEN,
  },
];

export const InviteCandidatesHeader: FC = () => {
  const { queryParams, updateQueryParams } = useQueryParams<QueryParams>();

  const sortOption = queryParams.recommendedUsersSortOption || RecommendedUsersSortOptionEnum.JOINED_AT;

  const onSort = (recommendedUsersSortOption: RecommendedUsersSortOptionEnum): void => {
    updateQueryParams({ recommendedUsersSortOption: recommendedUsersSortOption });
    trackEvent({
      context: MetricContext.OPENING_VIEW,
      interaction: MetricAction.SORT_FEED,
      payload: {
        'Sort Option': recommendedUsersSortOption,
      },
    });
  };

  return (
    <div className="opening-invite-candidates-header">
      <div className="opening-invite-candidates-header__text">
        <div className="opening-invite-candidates-header__title">Invite candidates</div>

        <div className="opening-invite-candidates-header__description">
          We've selected a set of candidates for you to review and invite to discuss your open position. All talents
          here are open for headhunting and are expecting your invitation.
        </div>
      </div>

      <div className="opening-invite-candidates-header__sorting">
        {SORT_OPTIONS.map(option => {
          return (
            <div
              className={classnames(
                'opening-invite-candidates-header__sorting-option',
                sortOption === option.value && 'opening-invite-candidates-header__sorting-option--active',
              )}
              key={option.value}
              onClick={() => onSort(option.value)}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
